import { useEffect, useState } from "react";
import Lenis from "lenis";
import "lenis/dist/lenis.css";
import { LangContext, setLenis } from "@/lib/site";
import { Header } from "@/components/site/Header";
import { Hero } from "@/components/site/Hero";
import { Marquee } from "@/components/site/Marquee";
import { Quotes } from "@/components/site/Quotes";
import { Ebooks } from "@/components/site/Ebooks";
import { About } from "@/components/site/About";
import { Footer } from "@/components/site/Footer";

function App() {
  const [lang, setLang] = useState("id");

  useEffect(() => {
    const lenis = new Lenis({ duration: 1.2, smoothWheel: true });
    setLenis(lenis);
    let id;
    const raf = (time) => { lenis.raf(time); id = requestAnimationFrame(raf); };
    id = requestAnimationFrame(raf);
    return () => { cancelAnimationFrame(id); lenis.destroy(); setLenis(null); };
  }, []);

  useEffect(() => { document.documentElement.lang = lang; }, [lang]);

  return (
    <LangContext.Provider value={{ lang, setLang }}>
      <div className="grain relative min-h-screen bg-[#070A12] text-slate-100">
        <Header />
        <main>
          <Hero />
          <Marquee />
          <Quotes />
          <Ebooks />
          <About />
        </main>
        <Footer />
      </div>
    </LangContext.Provider>
  );
}

export default App;
